import { render, staticRenderFns } from "./collectCharges.vue?vue&type=template&id=ca7a8fb4"
import script from "./collectCharges.ts?vue&type=script&lang=js&external"
export * from "./collectCharges.ts?vue&type=script&lang=js&external"
import style0 from "./collectCharges.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports